import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "reactstrap";
import { withTranslation } from "react-i18next";
import { environment } from "@/config";

const Footer = ({ t }) => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              {new Date().getFullYear()} © Ensuro - {environment.name}-{environment.version}.
            </Col>
            <Col md={12}>
              {t(
                "Ensuro is licensed to conduct digital asset business and general (re)insurance business by the Bermuda Monetary Authority."
              )}
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

Footer.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Footer);
